import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormArray } from '@angular/forms';
import { typeDHLFormControls } from '../../models/dhl-form-shared-types';
import { Modal } from 'src/app/common/modal/modal';
import { ModalService } from 'src/app/common/modal/modal.service';
import {MatDialog} from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-form-field-card',
    templateUrl: './form-field-card.component.html',
    styleUrls: ['./form-field-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldCardComponent implements OnInit {

  @Input() configData;
  @Input() frmGroup: UntypedFormGroup;
  
  constructor(private modalService: ModalService, private appService: AppService, public dialog: MatDialog) { }  

  showShipmentForm: boolean = false;
  formStatus;
  // shipmentList = [];

  getFormTableControls(){
    return this.frmGroup.controls[this.configData.name]['controls'];                
  }  
  
  getColsClass() {
    let cols = ["3", "4", "6", "12", "12"];
    const mediaBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
    let colsClass = '';
    for ( let i = 0; i < cols.length; i++) {
      colsClass += 'col-' + mediaBreakpoints[i] + '-' + cols[i] + ' ';
    }

    return colsClass;
  }

  ngOnInit() {    

    this.formStatus = this.frmGroup.status;

    if(!(localStorage.getItem('templateName') === "releaseOrderViewEdit")){
      this.frmGroup.get(this.configData.name)['shipmentList'] = [];
    } else {
      this.frmGroup.get(this.configData.name)['shipmentList'] = this.frmGroup.get(this.configData.name).value;
      this.addShipmentDataToList(null);
    }

    console.log(this.configData);
    this.appService.events$.forEach(event=>{ 
      if(event) {        
        if(!(Object.keys(event).length === 0 && event.constructor === Object)){          
          // this.shipmentList.push(event);
          if(event.position !== undefined && event.editMode){
            this.frmGroup.get(this.configData.name)['shipmentList'][event.position] = event.value;
          } else {
            this.frmGroup.get(this.configData.name)['shipmentList'].push(event.value);
            this.addShipmentDataToList(event);
          }

          // let qty;
          // qty = sessionStorage.getItem('qtyRelease');   // need to remove qtyRelease from everywhere
          // if(qty !== null){
          //   qty = parseInt(qty);
          //   qty -= parseInt(event.huCount);
          //   sessionStorage.setItem('qtyRelease', Math.abs(qty).toString());
          // }            
        }    
        console.log(this.frmGroup.get(this.configData.name).value[0]);                        
      }
    });
  }

  addShipmentDataToList(data) {
    // e.preventDefault();    
    // let form = this.frmGroup.get(this.configData.name)['controls'];        
    let grp ={};
    this.configData['controls'].forEach((field)=>{
      grp[field.name] = field.required === true ? new UntypedFormControl
                (Object.keys(field.defaultValue).length === 0 ? '' : field.defaultValue, 
                    [Validators.required, Validators.maxLength(parseInt(field['maxLength']))]) : 
                        new UntypedFormControl(Object.keys(field.defaultValue).length === 0 ? '' : field.defaultValue, 
                            Validators.maxLength(parseInt(field['maxLength'])));
    });       
    // if(data !== null){
    //   form[form.length-1].patchValue(data);
    // }    
    (<UntypedFormArray>this.frmGroup.controls[this.configData.name]).push(new UntypedFormGroup(grp));
    // form[form.length-1].reset();
  }
  
  openShipmentForm(){   

    // this.addShipmentDataToList(null);

    if(localStorage.getItem('lastShipCard') == 'true'){
      this.addShipmentDataToList(null);
    }
    let form = this.frmGroup.get(this.configData.name)['controls'];
    let modal = new Modal({
      action: false, name: 'purchaseOrder', title: 'Purchase Order', description: 'Shipment detail form', actionButtonText: '', 
      modalForm: {modalName: 'shipmentModalForm', template: this.configData, frmGroup: form[form.length-1], editMode: false }
    });
    this.modalService.createModalBox(modal, 200);
  }  

  deleteShipmentCard(e) {
    console.log(this.frmGroup);
    let form = this.frmGroup.get(this.configData.name)['controls'];        
    this.frmGroup.get(this.configData.name)['shipmentList'].splice(e, 1);    
    (<UntypedFormArray>this.frmGroup.controls[this.configData.name]).removeAt(e);              
    this.frmGroup.markAsTouched();
  }

  editShipmentForm(shipment, rowIndex){
    console.log(this.frmGroup.controls[this.configData.name]['controls'][rowIndex]);
    let shipmentForm = this.frmGroup.controls[this.configData.name]['controls'][rowIndex];
    let modal = new Modal({
      action: false, name: 'purchaseOrder', title: 'Purchase Order', description: 'Shipment detail form', actionButtonText: '', 
      modalForm: {modalName: 'shipmentModalForm', template: this.configData, frmGroup: shipmentForm, position: rowIndex, editMode: true }
    });
    this.modalService.createModalBox(modal, 200);
  }

  checkShipment(data){
    let count = 0;
    for (let g in data.value){
      console.log(data.value[g]);
      if(data.value[g] === null || data.value[g] === ''){
        count += 1;
      } 
    } 
    if(count===Object.keys(data.value).length){
      return false;
    } else {
      return true;
    }
  }

}
